import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { css, type Styles } from '@flipster/styled-system/css';
import { flex, vstack } from '@flipster/styled-system/patterns';

import IconLossProtection from '@web/assets/images/loss-protection/icon-loss-protection.png';

import { lossProtectionBunja } from './bunja';

const LossProtectedSection = ({ css: cssProps }: { css?: Styles }) => {
  const transAssets = useTranslations('Assets.r250401');
  const { isLossProtectedAtom } = useBunja(lossProtectionBunja);
  const isLossProtected = useAtomValue(isLossProtectedAtom);

  if (!isLossProtected) return null;

  return (
    <div
      className={css(
        flex.raw({
          gap: '12px',
          pt: '16px',
          borderTopWidth: '1px',
          borderTopStyle: 'solid',
          borderColor: 'border.default.level-2',
        }),
        cssProps,
      )}
    >
      <img src={IconLossProtection.src} alt='icon-loss-protection' className={css({ width: '24px', height: '24px' })} />
      <div
        className={vstack({
          gap: '4px',
          alignItems: 'flex-start',
          flex: 1,
        })}
      >
        <h3 className={css({ textStyle: 'Text/L/Strong', color: 'content.default.level-5' })}>
          {transAssets('Loss_protected')}
        </h3>
        <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-2' })}>
          {transAssets('You_will_receive_back_up_to_20_description')}
        </p>
      </div>
    </div>
  );
};

export default LossProtectedSection;
